<template>
  <div class="page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-button
          type="text"
          style="margin-right: 24px"
          icon="el-icon-arrow-left"
          @click="back"
        >
          返回
        </el-button>
        <el-form-item>
          <el-input
            v-model="query.form.name"
            clearable
            style="width: 250px;"
            :placeholder="edit.form.type === '3' ? '请输入编号/产品名称/包名/dp' : '请输入编号/产品名称/产品系'"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item v-if="edit.form.type !== '3'">
          <el-select
            v-model="query.form.customer_type"
            clearable
            placeholder="客户类型"
            style="width: 180px;"
            @change="handleFilter"
          >
            <el-option
              v-for="item in customerTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            plain
            type="primary"
            :loading="table.loading"
            @click="handleFilter"
          >
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleEdit('Add')"
          >
            添加
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <el-table
        :data="table.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="编号"
          width="150"
        />
        <el-table-column
          prop="name"
          label="产品名称"
        />

        <template v-if="edit.form.type === '3'">
          <el-table-column
            prop="android_package_name"
            key="android_package_name"
            label="Android包名"
          />
          <el-table-column
            prop="android_deeplink"
            key="android_deeplink"
            label="Android dp头"
          />
          <el-table-column
            prop="ios_package_name"
            key="ios_package_name"
            label="iOS包名"
          />
          <el-table-column
            prop="ios_deeplink"
            key="ios_deeplink"
            label="iOS dp头"
          />
        </template>
        <template v-else>
          <el-table-column
            prop="series"
            key="series"
            label="产品系"
          />
          <el-table-column
            prop="customer_type"
            key="customer_type"
            label="客户类型"
          >
            <template slot-scope="scope">
              {{ scope.row.customer_type | customerTypeFormat }}
            </template>
          </el-table-column>
        </template>

        <el-table-column
          label="状态"
          width="150"
        >
          <template slot-scope="scope">
            <el-tag :type="isValidStatus(scope.row.status) ? 'success' : 'danger'">
              {{ (status[scope.row.status * 1] || {}).text || '' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="230"
        >
          <template slot-scope="scope">
            <el-button
              v-show="hasChild(scope.row.level)"
              type="text"
              size="small"
              @click="handleView(scope.row)"
            >
              管理
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleEdit('Edit', scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleExStatus(scope.row)"
            >
              置为{{ isValidStatus(scope.row.status) ? '失效' : '有效' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- edit dialog -->
    <form-dialog
      :visible.sync="edit.display"
      :title="edit.type === 'Add' ? '添加' : '编辑'"
      :loading="edit.loading"
      width="500px"
      @submit="submitEditForm"
      @close="resetForm"
    >
      <el-form
        ref="editForm"
        :model="edit.form"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item
          label="产品名称"
          prop="name"
          :rules="[{ required: true, message: '产品名称不能为空' }]"
        >
          <el-input
            ref="editInput"
            v-model="edit.form.name"
            style="width:90%"
            @keyup.enter.native="submitEditForm"
          />
        </el-form-item>
        <template v-if="edit.form.type === '3'">
          <el-form-item
            label="Android包名"
            prop="android_package_name"
          >
            <el-input
              v-model="edit.form.android_package_name"
              style="width:90%"
              @keyup.enter.native="submitEditForm"
            />
          </el-form-item>
          <el-form-item
            label="Android dp头"
            prop="android_deeplink"
          >
            <el-input
              placeholder="多个dp用英文逗号隔开"
              v-model="edit.form.android_deeplink"
              style="width:90%"
              @keyup.enter.native="submitEditForm"
            />
          </el-form-item>
          <el-form-item
            label="iOS包名"
            prop="ios_package_name"
          >
            <el-input
              v-model="edit.form.ios_package_name"
              style="width:90%"
              @keyup.enter.native="submitEditForm"
            />
          </el-form-item>
          <el-form-item
            label="iOS dp头"
            prop="ios_deeplink"
          >
            <el-input
              placeholder="多个dp用英文逗号隔开"
              v-model="edit.form.ios_deeplink"
              style="width:90%"
              @keyup.enter.native="submitEditForm"
            />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item
            label="产品系"
            prop="series"
            :rules="[{ required: true, message: '产品系不能为空' }]"
          >
            <el-input
              v-model="edit.form.series"
              style="width:90%"
              @keyup.enter.native="submitEditForm"
            />
          </el-form-item>
          <el-form-item
          label="客户类型"
          prop="customer_type"
          :rules="[{ required: true, message: '请选择客户类型' }]"
        >
          <el-select
            v-model="edit.form.customer_type"
            placeholder="请选择客户类型"
            style="width: 90%"
          >
            <el-option
              v-for="item in customerTypesSelection"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        </template>
      </el-form>
    </form-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import FormDialog from '@/components/FormDialog';

const req = new Request();

const status = {
  '0': { text: '有效', id: 0 },
  '1': { text: '失效', id: 1 },
  '5': { text: '待审核', id: 5 },
};

export default {
  name: 'OperationManageDictSubList',
  components: { FormDialog },
  // 新增过滤器
  filters: {
    customerTypeFormat(value) {
      const mapping = { 1: 'KA', 2: '其他' };
      return mapping[value];
    },
  },
  data() {
    return {
      status,
      title: '',
      dictIds: [],
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          type: '',
          level: 1,
          parent_id: '',
          page: 1,
          page_size: 10,
          name: '',
          customer_type: '',
        },
      },
      edit: {
        type: 'Add',
        display: false,
        loading: false,
        form: {
          id: '',
          type: '',
          name: '',
          parent_id: '',
          series: '',
          customer_type: '',
          android_package_name: '',
          android_deeplink: '',
          ios_package_name: '',
          ios_deeplink: ''
        },
      },
      customerTypes: [
        { label: 'KA', value: 1 },
        { label: '其他', value: 2 },
        { label: '空', value: 0 },
      ],
      customerTypesSelection: [
        { label: 'KA', value: 1 },
        { label: '其他', value: 2 },
      ],
    };
  },
  methods: {
    // 获取列表数据
    async _getList() {
      try {
        const params = {
          ...this.query.form,
          customer_type:
            this.query.form.customer_type !== ''
              ? this.query.form.customer_type
              : undefined,
        };
        this.table.loading = true;
        // req
        let api;
        if (this.query.form.type === '3') {
          api = req.Apis.sales.product.productRead;
        } else {
          api = req.Apis.sales.common.dict;
        }
        const res = await req.send(api, params).fin(() => {
          this.table.loading = false;
        });
        const dv = res.data || {};
        this.table.list = [...(dv.data || [])];
        this.table.total = Number(dv.total || 0);
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    // async 提交编辑
    async processSubmitEdit() {
      try {
        const params = {
          ...this.edit.form,
        };
        this.edit.loading = true;
        let api;
        if (this.edit.form.type === '3') {
          api = req.Apis.sales.product[`product${this.edit.type}`];
        } else {
          api = req.Apis.sales.common[`dict${this.edit.type}`];
        }
        await req.send(api, params).fin(() => {
          this.edit.loading = false;
        });
        this.edit.display = false;
        this._getList();
        this.$message.success('成功！');
      } catch (err) {
        this.$message.error(`失败：${err.message || '未知错误'}`);
      }
    },

    // async 删除
    async processSubmitExStatus(id = '', status) {
      try {
        const params = {
          id,
          status,
        };
        let api;
        if (this.edit.form.type === '3') {
          api = req.Apis.sales.product.setStatus;
        } else {
          api = req.Apis.sales.common.dictEdit;
        }
        await req.send(api, params);
        this._getList();
        this.$message.success('成功！');
      } catch (err) {
        this.$message.error(`失败：${err.message || '未知错误'}`);
      }
    },

    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },

    // 管理
    handleView(o) {
      const makeId = (o) =>
        `${o.type || ''}-${Number(o.level || 1) + 1}-${o.id || ''}`;
      this.$router.push({
        name: 'OperationManageDictSubList',
        params: {
          dictId: [...this.dictIds, makeId(o)],
        },
        query: {
          title: this.title,
          maxLevel: this.maxLevel,
        },
      });
    },

    // 编辑
    handleEdit(type = 'Add', o = {}) {
      this.edit.display = true;
      this.edit.type = type;
      this.edit.form.id = o.id || '';
      this.edit.form.name = o.name || '';
      this.edit.form.series = o.series || '';
      this.edit.form.android_package_name = o.android_package_name || '';
      this.edit.form.android_deeplink = o.android_deeplink || '';
      this.edit.form.ios_package_name = o.ios_package_name || '';
      this.edit.form.ios_deeplink = o.ios_deeplink || '';
      this.edit.form.customer_type =
        o.customer_type !== undefined ? Number(o.customer_type) : null;

      this.$nextTick(function() {
        // eslint-disable-next-line no-invalid-this
        this.$refs.editInput.$el.querySelector('input').focus();
      });
    },

    // 删除
    handleExStatus(o) {
      const willStatus =
        this.status[this.isValidStatus(o.status) ? 1 : 0] || {};
      const title = `确认重置 <br/>【${o.id}-${
        o.name
      }】状态为 【${willStatus.text || ''}】？`;
      this.$confirm(title, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.processSubmitExStatus(o.id || '', willStatus.id);
      });
    },

    // 提交编辑
    submitEditForm() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.processSubmitEdit();
        } else {
          return false;
        }
      });
    },

    resetForm() {
      this.$refs['editForm'].resetFields();
    },

    // 是否有效
    isValidStatus(st = 1) {
      return Number(st) === this.status['0'].id;
    },

    // 是否有子集
    hasChild(level = 1) {
      return Number(level || 1) < this.maxLevel;
    },

    // 返回上一页
    back() {
      this.$router.go(-1);
    },

    // 初始化
    init(dictId) {
      const dictIds = typeof dictId === 'string' ? dictId.split('/') : dictId;
      this.dictIds = dictIds;

      const [type = '', level = 1, id = ''] = (
        dictIds[dictIds.length - 1] || ''
      ).split('-');
      this.query.form.page = 1;
      this.query.form.name = '';
      this.query.form.type = type;
      this.query.form.level = level;
      this.query.form.parent_id = id;

      this.edit.form.type = type;
      this.edit.form.level = level;
      this.edit.form.parent_id = id;

      this._getList();
    },
  },
  beforeRouteEnter(to, from, next) {
    const { title = '详情', maxLevel = 1 } = to.query || {};
    to.meta.label = title;
    next((vm) => {
      vm.title = title;
      vm.maxLevel = maxLevel;
      vm.init(to.params.dictId);
    });
  },
  beforeRouteUpdate(to, from, next) {
    const { title = '详情', maxLevel = 1 } = to.query || {};
    to.meta.label = title;
    this.title = title;
    this.maxLevel = maxLevel;
    this.init(to.params.dictId);
    next();
  },
};
</script>

<style lang="less" scoped>
.query-data {
  // table
  .query-table {
    position: relative;
    overflow: hidden;
  }
}
</style>
